import React, { useRef, useState, useContext,useEffect } from "react";
import {MyContext} from '../components/Context';
import axios from "axios";
import MovieCard from "../components/MovieCard";
import Loading from "./Loading";
import Carousel from "../components/Carousel";
import Hero from "../components/Hero";
import ShoppingCard from "../components/ShoppingCard";
import Shopping from "../components/Shopping";
import CartModal from "./CartModal";
import FetchData from "./FetchData";
 
function Home() {
  
  const {data,setdata,jewelery, setjewelery,electronics, setelectronics,loading,isLoading}=useContext(MyContext)

  return (
  
    <div className="bg-white font-raleway">
        <FetchData/>
      {loading && <Loading />}

     {/* <div className="flex justify-end"> <CartModal/></div> */}
      {/* {!loading && (
        <Shopping data={data} jewelery={jewelery} electronics={electronics} />
      )} */}
       
       <Shopping data={data} jewelery={jewelery} electronics={electronics} />
     
    </div>
  );
}

export default Home;
